<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">Team Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>Team Name</td>
                  <td>
                    {{ teamModel.name ? teamModel.name : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Team Id</td>
                  <td>
                    {{ teamModel.id ? teamModel.id : "" }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              large
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New Team</v-btn
            >
            <v-btn
              v-else
              large
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Team } from "@/models/Team";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      teamModel: new Team(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "Teams",
          disabled: false,
          href: "/admin/teams",
        },
        {
          text: "Team Details",
          disabled: false,
          href: `/admin/teams/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    team: {
      query: gql`
        query Team($id: ID!) {
          team(id: $id) {
            id
            name
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
          createdBy: self.me.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.teamModel.id = this.team.id;
        this.teamModel.name = this.team.name;
        this.teamModel.createdBy = this.team.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
